module.exports = __webpack_public_path__ + "img/car.86202986.png";